import { useCallback } from 'react';
import type { MapViewState } from '@deck.gl/core';
import { atom, useAtomValue, useSetAtom } from 'jotai';

type UseMapViewState = {
  mapViewState: MapViewState;
};

type UseMapViewStateUpdater = {
  updateMapViewState: (changes: Partial<MapViewState>) => void;
  resetMapViewState: () => void;
};

// 地図の初期状態(GEOTRA社オフィス)
const DEFAULT_MAP_VIEW_STATE: MapViewState = {
  longitude: 139.763014,
  latitude: 35.687833,
  zoom: 12,
  pitch: 0,
  bearing: 0,
};

const mapViewStateAtom = atom<MapViewState>(DEFAULT_MAP_VIEW_STATE);

const useMapViewState = (): UseMapViewState => {
  const mapViewState = useAtomValue(mapViewStateAtom);

  return { mapViewState };
};

const useMapViewStateUpdater = (): UseMapViewStateUpdater => {
  const setMapViewState = useSetAtom(mapViewStateAtom);

  const updateMapViewState = useCallback(
    (changes: Partial<MapViewState>): void => {
      setMapViewState((currentViewState: MapViewState): MapViewState => {
        return { ...currentViewState, ...changes };
      });
    },
    [setMapViewState]
  );

  const resetMapViewState = useCallback((): void => {
    setMapViewState(DEFAULT_MAP_VIEW_STATE);
  }, [setMapViewState]);

  return { updateMapViewState, resetMapViewState };
};

export { useMapViewState, useMapViewStateUpdater };
